import { T } from '../../helpers/i18n';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import { UserPickerField } from './UserPickerField';

export const Watchers = () => (
  <UserPickerField
    fieldName={ISSUE_ATTRIBUTE_NAMES.WATCHERS}
    label={T.translate('new.watchers') as string}
  />
);
